/**
 * React Query hooks for sport-specific progression endpoints.
 */

import { useAuthenticatedQuery } from "./useAuthenticatedQuery";
import { fetchProgression } from "@/lib/exerciseApi";

const KEYS = {
  progression: "progression",
} as const;

export function useProgression(sport: string | null) {
  return useAuthenticatedQuery({
    queryKey: [KEYS.progression, sport],
    queryFn: () => fetchProgression(sport!),
    enabled: !!sport,
    staleTime: 5 * 60 * 1000,
  });
}
